import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/mixpanel";

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    clarity?: (...args: any[]) => void;
    vector?: { on?: (...args: any[]) => void };
  }
}

export default function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    const url = location.pathname + location.search;

    // --- GA4: manual SPA pageview tracking ---
    window.gtag?.("config", "G-9C68SR5BW0", { page_path: url });

    // --- Clarity: update current page context ---
    window.clarity?.("set", "page", url);

    // --- Vector (optional manual event) ---
    // window.vector?.on?.("page", { path: url });

    // --- Mixpanel: SPA pageview tracking ---
    trackPageView(url);

    // --- Leadsy.ai: load once globally ---
    if (!document.getElementById("vtag-ai-js")) {
      const script = document.createElement("script");
      script.id = "vtag-ai-js";
      script.async = true;
      script.src = "https://r2.leadsy.ai/tag.js";
      script.setAttribute("data-pid", "dwbYOVMPUPIEPyNq");
      script.setAttribute("data-version", "062024");
      document.head.appendChild(script);
    }

    // --- Leadsy.ai: send pageview for SPA navigation ---
    // Wait until script is ready, then trigger event
    const sendLeadsyPage = () => {
      if (window && (window as any).leadsy?.page) {
        (window as any).leadsy.page({ path: url });
      }
    };

    // try immediately, then retry if needed
    sendLeadsyPage();
    const timeout = setTimeout(sendLeadsyPage, 1000);

    return () => clearTimeout(timeout);
  }, [location.pathname, location.search]);

  return null;
}
